import {Injectable} from '@angular/core';
import {Subject, Observable} from "rxjs";

@Injectable()
export class GlmModalService {

    private subject = new Subject<any>();

    constructor() {
    }

    cerrarModal(){
        this.subject.next({accion: 'cerrar-modal'});
    }

    getModalObservable(): Observable<any> {
        return this.subject.asObservable();
    }
}